import React, { Component } from 'react'
import Constantes from '../php/Constantes';

class AlertasFuncionario extends Component {
    constructor(props){
        super(props);
        this.state = {
            mostrarAlerta: false,
            mostrarAlertaNivel: false,
            mostrarAlertaCal: false,
            mostrarAlertaRetroactividad: false,
        }
    }

    async componentDidMount(){
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/verificar_alertasFuncionario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datos = await respuesta.json();
        if((datos[0] === 'si')){
            this.setState({
                mostrarAlerta: true,
            })
        }
        if((datos[1] === 'si')){
            this.setState({
                mostrarAlertaNivel: true,
            })
        }
        if((datos[2] === 'si')){
            this.setState({
                mostrarAlertaCal: true,
            })
        }
        if((datos[3] === 'si')){
            this.setState({
                mostrarAlertaRetroactividad: true,
            })
        }
    }

    render(){
        return (
            <>
                {this.state.mostrarAlerta ? (<div className='alert alert-danger' style={{textAlign:'center'}}> Tiene notificaciones pendientes </div>) : null}
                {this.state.mostrarAlertaNivel ? (<div className='alert alert-danger' style={{textAlign:'center'}}> Tiene pendiente ingresar el nivel educativo </div>) : null}
                {this.state.mostrarAlertaCal ? (<div className='alert alert-danger' style={{textAlign:'center'}}> Tiene pendiente notificarse su calificación (Sección Calificaciones)</div>) : null}
                {this.state.mostrarAlertaRetroactividad ? (<div className='alert alert-danger' style={{textAlign:'center'}}> Tiene pendiente notificarse sobre la regularización</div>) : null}
            </>
        )
    }
}

export default AlertasFuncionario